Object.defineProperty(exports, '__esModule', { value: true });

var en = {
  code: 'km',
  week: {
    dow: 0,
    doy: 4
  },
  direction: 'ltr',
  buttonText: {
    prev: 'មុន',
    next: 'បន្ទាប់',
    prevYear: 'ឆ្នាំមុន',
    nextYear: 'ឆ្នាំបន្ទាប់',
    year: 'ឆ្នាំ',
    today: 'ថ្ងៃនេះ',
    month: 'ខែ',
    week: 'សប្ដាហ៍',
    day: 'ថ្ងៃ',
    list: 'បញ្ជី'
  },
  weekText: 'W',
  allDayText: 'All-day',
  moreLinkText: 'More',
  noEventsText: 'No events to display'
};

exports.default = en;
